module.exports = __webpack_public_path__ + "static/media/app-development.f031df8f.png";